import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { FooterComponent } from './components/footer/footer.component';
import { MenuComponent } from './components/menu/menu.component';
import { PersonalInfoSubMenuComponent } from './components/personal-info-sub-menu/personal-info-sub-menu.component';
import { HeaderComponent } from './components/header/header.component';
import { SidebarModule } from 'primeng/sidebar';
import { CustomConfirmDialogueComponent } from './components/custom-confirm-dialogue/custom-confirm-dialogue.component';
import { DialogModule } from 'primeng/dialog';
import { DashboardMenuComponent } from './components/dashboard-menu/dashboard-menu.component';
import { AdminSearchComponent } from './components/admin-search/admin-search.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { SubscriptionSubMenuComponent } from './components/subscription-sub-menu/subscription-sub-menu.component';
import { CustomSubConfirmationDialogueComponent } from './components/custom-sub-confirmation-dialogue/custom-sub-confirmation-dialogue.component';
import { SmartMenuComponent } from './components/smart-menu/smart-menu.component';
import { TeamWebsiteSubMenuComponent } from './components/team-website-sub-menu/team-website-sub-menu.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { SafeHTMLPipe } from './pipes/safe-html.pipe';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { AccordionModule } from 'primeng/accordion';
import { CustomUrlConfirmationPopupComponent } from './components/custom-url-confirmation-popup/custom-url-confirmation-popup.component';
import { CoreEmployeeSearchComponent } from './components/core-employee-search/core-employee-search.component';
import { FormatPhoneDirective } from './directives/formatPhone.directive';
import { AllowCharactersDirective } from './directives/acceptCharacter.directive';
import { ConfirmationPopupWithTableComponent } from './components/confirmation-popup-with-table/confirmation-popup-with-table.component';
import { CloneDialogBoxComponent } from './components/clone-dialog-box/clone-dialog-box.component';
import { TableModule } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import {TabViewModule} from 'primeng/tabview';
import { SearchUpdateConfirmationComponent } from './components/search-update-confirmation/search-update-confirmation.component';
import {CalendarModule} from 'primeng/calendar';
import { OfficeWebsiteSubMenuComponent } from './components/office-website-sub-menu/office-website-sub-menu.component';
import { LeadsCrmSubMenuComponent } from './components/leads-crm-sub-menu/leads-crm-sub-menu.component';
import { CustomConfirmationLeadsDialogueComponent } from './components/custom-confirmation-leads-dialogue/custom-confirmation-leads-dialogue.component';
import {CarouselModule} from 'primeng/carousel';
import { PhoneNumberHyphenPipe } from './pipes/phone-number-hyphen.pipe';
import { SearchPageComponent } from './components/search-page/search-page.component';
import { CustomShowcaseConfirmationPopupComponent } from './components/custom-showcase-confirmation-popup/custom-showcase-confirmation-popup.component';
import { OfficevideoInstructionDialogComponent } from './components/officevideo-instruction-dialog/officevideo-instruction-dialog.component';
import { AgreementConfirmationModalComponent } from './components/agreement-confirmation-modal/agreement-confirmation-modal.component';

@NgModule({
  declarations: [
    WelcomeComponent,
    FooterComponent,
    MenuComponent,
    PersonalInfoSubMenuComponent,
    HeaderComponent,
    CustomConfirmDialogueComponent,
    DashboardMenuComponent,
    AdminSearchComponent,
    SubscriptionSubMenuComponent,
    CustomSubConfirmationDialogueComponent,
    SmartMenuComponent,
    TeamWebsiteSubMenuComponent,
    SafeHTMLPipe,
    ErrorPageComponent,
    CustomUrlConfirmationPopupComponent,
    CoreEmployeeSearchComponent,
    FormatPhoneDirective,
    AllowCharactersDirective,
    ConfirmationPopupWithTableComponent,
    CloneDialogBoxComponent,
    SearchUpdateConfirmationComponent,
    OfficeWebsiteSubMenuComponent,
    LeadsCrmSubMenuComponent,
    CustomConfirmationLeadsDialogueComponent,
    PhoneNumberHyphenPipe,
    SearchPageComponent,
    CustomShowcaseConfirmationPopupComponent,
    OfficevideoInstructionDialogComponent,
    AgreementConfirmationModalComponent
    
  ],
  imports: [
    CommonModule,
    SidebarModule,
    DialogModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    FormsModule,
    AngularEditorModule,
    AccordionModule,
    TableModule,
    CheckboxModule,
    TabViewModule,
    CalendarModule,
    CarouselModule
  ],
  exports: [
    FooterComponent,
    MenuComponent,
    HeaderComponent,
    SidebarModule,
    PersonalInfoSubMenuComponent,
    CustomConfirmDialogueComponent,
    DashboardMenuComponent,
    AdminSearchComponent,
    SubscriptionSubMenuComponent,
    CustomSubConfirmationDialogueComponent,
    CustomUrlConfirmationPopupComponent,
    SmartMenuComponent,
    TeamWebsiteSubMenuComponent,
    OfficeWebsiteSubMenuComponent,
    CoreEmployeeSearchComponent,
    AngularEditorModule,
    SafeHTMLPipe,
    FormatPhoneDirective,
    AllowCharactersDirective,
    ConfirmationPopupWithTableComponent,
    CloneDialogBoxComponent,
    TableModule,
    CheckboxModule,
    TabViewModule,
    SearchUpdateConfirmationComponent,
    CalendarModule,
    AutoCompleteModule,
    DialogModule,
    LeadsCrmSubMenuComponent,
    CustomConfirmationLeadsDialogueComponent,
    CarouselModule,
    FormsModule,
    PhoneNumberHyphenPipe,
    SearchPageComponent,
    CustomShowcaseConfirmationPopupComponent,
    OfficevideoInstructionDialogComponent,
    AgreementConfirmationModalComponent
  ],
  providers: [DecimalPipe]
})
export class SharedModule { }
